// src/components/home/Cta.js
import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/variables';
import { useModal } from '../../contexts/ModalContext';

const CtaSection = styled.section`
  padding: 80px 24px;
  text-align: center;
  background: linear-gradient(135deg, #8675c8 0%, #00a759 100%);
  color: ${colors.white};
`;

const CtaContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const CtaTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  color: ${colors.white};
`;

const CtaSubtitle = styled.p`
  font-size: 18px;
  margin-bottom: 32px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const Button = styled.button`
  display: inline-block;
  background-color: ${colors.white};
  color: ${colors.secondary};
  padding: 16px 32px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 18px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.2s, color 0.2s;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.9);
  }
`;

const Cta = () => {
  const { openConsultationModal } = useModal();
  
  return (
    <CtaSection>
      <CtaContainer>
        <CtaTitle>지금 바로 시작하세요</CtaTitle>
        <CtaSubtitle>
          ElectroWave Club과 함께라면 여러분도 실력있는 개발자로 성장할 수 있습니다.
        </CtaSubtitle>
        <Button onClick={openConsultationModal}>
          교육상담 신청하기
        </Button>
      </CtaContainer>
    </CtaSection>
  );
};

export default Cta;